import useRegistration from '@/domain/composables/use-registration'
import useEvent from '@/domain/composables/use-event'
import store from '@/store'
import { compareId } from '@/utils'

export default class RegistrationService {
  static async handleLinkedRegistration(eventId) {
    try {
      const linkedEventId = store.state.registration.childReg

      if (!linkedEventId) {
        return
      }
      const isAlreadyRegistered =
        await RegistrationService.checkIsRegistrationExist(linkedEventId)

      if (isAlreadyRegistered) {
        console.warn('already registered on quick-link linked event')
        return
      }

      const { getEventLinks } = useEvent()

      const eventLinksWithEventData = await getEventLinks(eventId).catch(
        (e) => {
          console.error(e)
          return []
        },
      )

      const link = eventLinksWithEventData.find((e2e) =>
        compareId(e2e.childId, linkedEventId),
      )

      if (!link) {
        console.error(`event ${linkedEventId} is not child of event ${eventId}`)
        return
      }

      if (!link.quickRegistration) {
        console.error(
          `event ${linkedEventId} does not have a quick registration`,
        )
        return
      }

      const { quickRegistration } = useRegistration()
      await quickRegistration(linkedEventId, eventId)
    } catch (e) {
      throw e
    } finally {
      store.commit('registration/SET_CHILD_REG', null)
    }
  }

  /**
   * Проверка регистрации пользователя
   * Если не указать параметр explicitEventId по умолчанию проверяется регистрация
   * на текущее мероприятие
   * @param {string} [explicitEventId]
   */
  static async checkIsRegistrationExist(explicitEventId = null) {
    const userData = store.state.auth.userData
    const authGroupId = store.getters['domain/currentAuthGroupId']
    const eventId = explicitEventId ?? store.getters['event/currentEventId']

    const { isUserHasRegistration } = useRegistration()
    const {
      data: { isRegistrationExist },
    } = await isUserHasRegistration(userData.email, eventId, authGroupId)

    return isRegistrationExist
  }
}
